export enum GraphYAxisPositionEnum {
  LEFT = 'left',
  RIGHT = 'right'
}
